'use client';

import Link from 'next/link';

type TermsConsentCheckboxProps = {
  checked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
};

export function TermsConsentCheckbox({ checked = false, disabled = false, onChange }: TermsConsentCheckboxProps) {
  return (
    <label className="flex min-h-[44px] cursor-pointer items-start gap-3 rounded-lg border border-white/[0.06] bg-white/[0.03] p-3 transition-colors hover:border-primary-400/30 hover:bg-white/[0.05]">
      <input
        data-testid="sms-consent"
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.checked)}
        className="mt-0.5 h-5 w-5 rounded border-dark-border bg-dark-card text-primary-500 focus:ring-primary-500 disabled:cursor-not-allowed"
      />
      <span className="text-xs text-dark-muted leading-relaxed">
        I agree to the BizRnR{' '}
        <Link href="/terms" target="_blank" rel="noopener" className="text-primary-400 underline underline-offset-2">
          Terms
        </Link>{' '}
        and{' '}
        <Link href="/privacy" target="_blank" rel="noopener" className="text-primary-400 underline underline-offset-2">
          Privacy Policy
        </Link>
        , including verification and service text messages.
      </span>
    </label>
  );
}
